import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Modal } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import ConsignmentFreightItemForm, {} from "./ConsignmentFreightItemForm";
import ConsignmentHasBeenInvoicedAlert from "./ConsignmentHasBeenInvoicedAlert";
const ConsignmentFreightItemModal = ({ open, consignment, editingFreightLine, editMode, canChangeSavedProduct = true, showTrackingCode = true, showWasteRecordId = true, showDescription = true, onCancel, onUpdate }) => {
    const freightItemFormRef = useRef(null);
    const [networkRequestInProgress, setNetworkRequestInProgress] = useState(false);
    const isEditing = editingFreightLine && editingFreightLine.id && true;
    const dialogTitle = isEditing ? "Edit Freight" : "Add Freight";
    const okText = isEditing ? "Update" : "Add";
    const handleUpdateFreight = () => {
        freightItemFormRef.current?.validateFields().then(freightItem => {
            setNetworkRequestInProgress(true);
            const inUpdateMode = editingFreightLine && editingFreightLine.id && true;
            const url = inUpdateMode ?
                `/admin/v1/consignments/${consignment.id}/freight/${editingFreightLine?.id}`
                : `/admin/v1/consignments/${consignment.id}/freight`;
            const method = inUpdateMode ? "put" : "post";
            axios(url, { method, data: freightItem })
                .then((response) => onUpdate && onUpdate(response.data))
                .catch(axiosErrorHandler)
                .finally(() => setNetworkRequestInProgress(false));
        }).catch(console.error); // This has to be present otherwise antd crashes :(;
    };
    return (_jsxs(Modal, { title: dialogTitle, okText: okText, open: open && !!consignment, onCancel: onCancel, onOk: handleUpdateFreight, confirmLoading: networkRequestInProgress, destroyOnHidden: true, children: [consignment &&
                _jsx(ConsignmentFreightItemForm, { ref: freightItemFormRef, tenantId: consignment.tenantId, editMode: editMode, freightItem: editingFreightLine, canChangeSavedProduct: canChangeSavedProduct, showTrackingCode: showTrackingCode, showWasteRecordId: showWasteRecordId, showDescription: showDescription }), open && consignment && consignment.marketplaceListings?.length > 0 &&
                _jsx(ConsignmentHasBeenInvoicedAlert, { consignmentId: consignment.id, consignmentStatus: consignment.status })] }));
};
export default ConsignmentFreightItemModal;
